
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as HomenchGK6B7k_13hiRhhzj9zw7VGpR5JShG0Y9A5gsx4QEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home.vue?macro=true";
import { default as _91id_93sL2zMr_6ZsXaN2CNDJ6NAf6WwqfL4VTxQ8NStjFtU9AMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[id].vue?macro=true";
import { default as listj1UDegAqOOERXB_BcmZ7nx8_Dbk1r_uF8x1sPXJPY3IMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/list.vue?macro=true";
import { default as player0dJ6XkFhvlngncKv2meFKzgqTGqwe_yrMv5YDIE2nlwMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/player.ts?macro=true";
import { default as helperhvpJehqXfgR2odxToHmVavX1r2g6ISuWpysTjSInjtUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/helper.ts?macro=true";
import { default as Resultxy_MIqkr7TVeZ35_ERJz7tCH5H4Qw4hWFH6F2gN9fp0Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result.vue?macro=true";
import { default as indexHoh4mAHqmjYEgHdwnfBtdugpsefUo3I9yeqzzxSmmXgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/trip/index.vue?macro=true";
import { default as indexUcjFXDkcypPQ8mxRc5Q2tShg1M6AaagJ9bsvHDaxfhsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/index.vue?macro=true";
import { default as helperWYPEZdv6mN_yGlYtc_j4FQn7Y36ID9KZXXSNEXw2gTsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/helper.ts?macro=true";
import { default as index0eg_LNH5dyyup6xJ2DImMl84SntoVSknIl_ut70MQqEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/index.vue?macro=true";
import { default as serviceTKOu4JgUgK5kFmSHLEb_HvBvosUYnoVI4UCXGuBjGDkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/service.ts?macro=true";
import { default as helperrsyI4PL_5i51S5NijA1AJAFVzkxIeSsEUoPo93IbNXYMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/helper.ts?macro=true";
import { default as ticketHuXVe5gyYzUO01iI62IHC3sfGbEEPcf4VQxnea9yZVsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket.vue?macro=true";
import { default as ticket_45ensnvNi4Hesys_U1QVGhnsXBae_06OFePdUYFoxrxM7oUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket-en.vue?macro=true";
import { default as nepcon7t9frr1AWfnUk3IX1_F5e0JORH4SrnH5zJ2Gx01OH_kMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/formData/nepcon.ts?macro=true";
import { default as MapDialogqGhtbViFTQOLlTauCKQyTzWe5yTPPf_kUayUm35aksMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MapDialog.vue?macro=true";
import { default as RepaymentXNh9jKIb_GT4VdFzF27xvG083Q_edbMrhOk6QAQOM2sMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/Repayment.vue?macro=true";
import { default as TicketStepsad_clL8UK438WpUOjGfZLwXK8NxKQsGaUhaL5yRQZJcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSteps.vue?macro=true";
import { default as FairBasicInfoICGVdw3FP10H63slEjW1bkQKMh_oMKjv8didjXPsPJ4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfo.vue?macro=true";
import { default as FairTimeStatuskWIQRk8X0Jv3ueIuFO0H9qgYNIv2Uk3_yacaad_00xsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairTimeStatus.vue?macro=true";
import { default as PaymentSectionCSKUFwgyt3qmCznkOJTs8QXeI1kYTLh0yl8sknkFpFcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PaymentSection.vue?macro=true";
import { default as CareerTicketTip4nNMB_Ikl3U7RPmA_Cch_9Mh70slufd_qfmgK3Fav5cMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CareerTicketTip.vue?macro=true";
import { default as FairCoverQrcoder7foZ83ot3fjzjdp5GqYVNVmYBp1GE9gnKnDkD4gFSkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairCoverQrcode.vue?macro=true";
import { default as FairNameDisplayMfU_6qHJtSmV7NA6DB0GcanyNxL1FBKx1A_ka_h9bAkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairNameDisplay.vue?macro=true";
import { default as NameInputDialogFP_J97EqXgJAID7lPFYiRjzLppQPeauEF8KxPVyE7R4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/NameInputDialog.vue?macro=true";
import { default as TicketSelection7laHbhrYsTa6aBlrESTnk52FC7K3a_QscNpJAhKF6IYMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSelection.vue?macro=true";
import { default as FairImageGalleryxB5CwDgXIXvghJIUF6WU5jAb7mbn3bc0ToKZovpxT6UMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairImageGallery.vue?macro=true";
import { default as FairIntroductionrEfd5G9bimSnPqvt_Q0NMbYQKRlbJ4xKL3BwG9XJWTMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairIntroduction.vue?macro=true";
import { default as IndustryFairListV2ByMKokFIWRdbbCJBKwDDxEQjuby3DtCs4x9LEWskMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/IndustryFairList.vue?macro=true";
import { default as TicketBreadcrumbxZS9dxm9VmAy6l3FGvIpMQ_VSvqM9L2og4XJqpcYhY4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketBreadcrumb.vue?macro=true";
import { default as TicketInfoCardh2bnuWVpcQ1_BvJ6oGu_0NjLkq6Mwrrw5V3oyerABGEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketInfoCard.vue?macro=true";
import { default as TicketTypeCardXcNy5GG6WRL_lF0F7_YAk8hDSaMpt6kdCn11CykyrhEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeCard.vue?macro=true";
import { default as MiniProgramDialoghvg4InDcd3XkASq6IxQkVZSnApMdKjykAgxsevqo_u4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MiniProgramDialog.vue?macro=true";
import { default as RepeatOrderDialogj6BMLU0OwVqwjHBGvsoH8OtEeTJSQSDZ9NAePcbTbnAMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/RepeatOrderDialog.vue?macro=true";
import { default as VisitorFormDialogn87Le268irKhUCUYP_cqPtDf80g4rSTJDPWYSZK6SF0Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorFormDialog.vue?macro=true";
import { default as VisitorManagementiKO7s9nZxDqTHd2jaFVkCJnFQ7NDdp9SUHeRAsEl70MMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorManagement.vue?macro=true";
import { default as SameFairExhibitionqJMwFQgGjDTPnZVMlx9lcveIhkJk_AqaO9Fhl6dgcnsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/SameFairExhibition.vue?macro=true";
import { default as TicketRightSidebarVXbBuhOwDOI_fvS99V0RhXP6BlW9u3wpdweJ6YnMdPoMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketRightSidebar.vue?macro=true";
import { default as ElectronicTicketTipj2t8OK5HsAr2h632M7Kq_yPgJ3Tgx386ntwfFHUWBC4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/ElectronicTicketTip.vue?macro=true";
import { default as TicketPurchaseGuideIZ1YuMm6x4ShQChi_QPsWj3pBdmBw3M4KTuf_FUrXTUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketPurchaseGuide.vue?macro=true";
import { default as VisitorManagementpTz653LL4MEYOjNTGxyyJ8Y2NDNSus8EUxccF5Ty8hMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/VisitorManagement.vue?macro=true";
import { default as CompanyCertificationt_cGHJfo6AVE4r5VCbXeYgDzN4LZfADGSU8GOlOhceYMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyCertification.vue?macro=true";
import { default as FairBasicInfoDetails_IWQppqoirp8uThDtRtubN8RSimL0VQMz_5MPiTaSrkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfoDetails.vue?macro=true";
import { default as PrivacySubmitSectionYMqTC6KcXkxkvB4BKfp7A_ORvL_OZZI4kfgON_pnCqYMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PrivacySubmitSection.vue?macro=true";
import { default as TicketTypeSelectortQRGD5a4QIDbcd9jtvlge_Fit7pGHtgoemGu7wXw_v4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeSelector.vue?macro=true";
import { default as BusinessLicenseUpload3j3AByTIsRT4utzz_MtMjsEaZB3ds3sRH3mvUSRgIE8Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/BusinessLicenseUpload.vue?macro=true";
import { default as TicketPurchaseGuideiYD_p5FOpTUdut_pk_ZhI5pm5QSnyk33BJDPCkKZX_4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketPurchaseGuide.vue?macro=true";
import { default as CompanyPersonalSelectorNTocTkco1Bhv14f82eukb7pkRZit79RPMBMlr0k8CXcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyPersonalSelector.vue?macro=true";
import { default as UploadAndProductInputbiLyNHB3s5GLYhY_MLCi_W643RQ2Bi9Iq2yVFiGYDBcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/UploadAndProductInput.vue?macro=true";
import { default as ticketVxlioSYvEbfmu9_QgqUfodefVkCXvPWQNGFYSRQdJ1cMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket.vue?macro=true";
import { default as top1002BApkt3O_FOXqrF4dRDuqjNjCCgvdoReCFMXIgfOU60Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/top100.vue?macro=true";
import { default as topDataeMx1ieKrf4Pf87kPV6nr5uIfgSYoT23taGnnXpVN3EgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/topData.ts?macro=true";
import { default as indexFNBD926fzSy7ADLsiPb157Vfa5GZddLyOq2jU5_RF1MMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/login/index.vue?macro=true";
import { default as index5ZoLEKuECTHvw_Ffy3WKDE20G_4zVh2hGbcvj0KiVhwMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/terms/index.vue?macro=true";
import { default as detail96u4qsHNVf1eiyF08c8OJSDux0GZ4sexyn7VMwcr9D0Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/detail.vue?macro=true";
import { default as _91id_931gkaV_z8I7t5AtTGLDmfvhFvb_maJaaodHvmCLLMhqcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/[id].vue?macro=true";
import { default as list90N8jMX3LCZe4BrMDRW2PEcrxD0Lt1pF3pb7NjQ9xWAMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/list.vue?macro=true";
import { default as Home_45enup3syjEkW4MBfIN1uKfRPQXz6J0_Escndr2gsXRHy7wMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home-en.vue?macro=true";
import { default as authkkxPYEcxVZJM1nmJ1VyrqhTzBM49IyXdlI02A_7dZDIMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/auth.vue?macro=true";
import { default as visaq8uXgBlzWewt_GmMW7I15H0S6EHvp98s4TUb3EPjAa4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visa.vue?macro=true";
import { default as errorG0LIVzo9TnmuIjPC_18x6h0mYUi1GJybN_SnC0pN5hEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/error.vue?macro=true";
import { default as indexeDAeOa_wVlJrw_7YvGFcM7MyO_M1cn8PNJPBfRyZ3FsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/index.vue?macro=true";
import { default as Centercjyku_74_vtvnamHOCpc70A0JAFeo7MGk7qNr6pnuh8Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center.vue?macro=true";
import { default as proxyExhisE6pqC1feL_a6mW3wc233IGXuL51ajVJ0iD8N9p6RsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/proxyExh.vue?macro=true";
import { default as indexEpqcoV67TaE1TP59ri_mn9dxAU6nBqfTTIhQS6y5JZ4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/index.vue?macro=true";
import { default as Result_45enm9B6Sd9tpUnyf6E_wyVjnd6aVg8SqU7EaSg5ECiDVwUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result-en.vue?macro=true";
import { default as indexyAv5NiqcBTyZqdEXOrVpxKJ_BSIM_esa4cLx6JFx6gcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/index.vue?macro=true";
import { default as indexMnkuPEMr_8VSUpeblhXd80jrU8h5Bm3vuFg4sR4KKWkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/special/index.vue?macro=true";
import { default as _91status_93oa4RT6WKjAtzgrRv4XZdvQuJbUQrSrOMW_2_ETwE4CgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[status].vue?macro=true";
import { default as DetailsmjWTsZ648CbM5YMUGKDCSeyEkL2gJp5T3M5Oo8zFtigMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details.vue?macro=true";
import { default as detailezzry0JcAdIdQWAafEYSQC_xZxuZwg5OFws1e0ojKEAMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/detail.vue?macro=true";
import { default as index7PcBhuIUPS8oC4dUTqoC42DZrBN0tRdNzdXpyVOQj1AMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index.vue?macro=true";
import { default as index4P6SvI9vCPrRL9255q4iF0XUiwScPCnkjgQlnuKyNHoMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/data/index.ts?macro=true";
import { default as News_PmPakixt0ALlHIb_RnRyoKDBtnvRVW3IzbALOsT22cMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News.vue?macro=true";
import { default as lettergUHT8eP1Dj11S4c9W12agu1noxVC0uFRkw5BzfUcYoUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letter.vue?macro=true";
import { default as payResult_Nwhq3IoIKkUV93YSGnWAW_K7_CnIZ8jUiaBxjDhufAMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payResult.vue?macro=true";
import { default as advertise3kB7YP1sFDM9BidvD8yJHPtR399xJlPaGh__fMRd9T4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/advertise.vue?macro=true";
import { default as indexKJRUG0IN6jEx10m4_sMSwSBCHkvNint_PuILjmpVEAgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/data/index.ts?macro=true";
import { default as indexsPNA7NzcNecPKIRx6OrOG8lIvmP3LsZ4gUp55klDtUgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/community/index.vue?macro=true";
import { default as _91id_93cb4DOHP8Pid0tYF4ZdbPo_Tp_3JlGjsPga5lTxkoRXsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhibitors/[id].vue?macro=true";
import { default as indexwKw3SmGTerWVbAZUcMoHdW06oP7zKh_OdlNW3QggX74Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index.vue?macro=true";
import { default as periodicalQpjoKpx3iRUTQkD2_lLTEab3NqGI4TqlYtKpcL082YQMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical.vue?macro=true";
import { default as ticket_freel54sJv3gIlIgmffr6TicqCppRLQ_MbJBncYwFidRlTUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket_free.ts?macro=true";
import { default as fair_45myf8DGGkNUI_2Ud9Df1pWjvI8KZU2As7JtcCET0BeZCHMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-my.vue?macro=true";
import { default as news_45myXkjvl7wzvhsywasA6AvYIT6nJks9UlV4qDsS8jiNVrwMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-my.vue?macro=true";
import { default as visitorG1zwiDgtlGyScttH4TdE46hLp7Iisb1ZJCRMxe9mLwkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor.vue?macro=true";
import { default as Center_45enQmU4Qqp7ML4b9nyBJTHQ2BQGLHdT72gWyyUhDBaAUTUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center-en.vue?macro=true";
import { default as payment_45newNOg_XuVsyjkfrQwI01nyU4YLDBO5ZqVchBUsLRNMuaEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payment-new.vue?macro=true";
import { default as submitOrderN0Fydx1kfhGEZUhrm0610__7d6oraMSshexAa8lsVrQMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/submitOrder.vue?macro=true";
import { default as index_45nuxt3z2UZAba4iEps2rGAuqFGHgMNa_iypN8TTx7L_IyAI1YMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/index-nuxt3.vue?macro=true";
import { default as Details_45enmIdJ7bcep9yvu9RBSFUjUKi511hJ1zuZxKbtWLkmaskMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details-en.vue?macro=true";
import { default as index_45env_feM_i2e6ccoBQ_LXRU_udixKF_4ids3bKvVZYcvR4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index-en.vue?macro=true";
import { default as letterInfoUyAIH9oKxhCRJOb4tLqv_r7fVeij1epo64fTrBiA4UEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/letter/letterInfo.vue?macro=true";
import { default as ticket_45my2hhF6dQbcpHLIeCaR5h1t_bSpd92SGApygZEc_v_n2YMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/ticket-my.vue?macro=true";
import { default as News_45enbrKL6yH2bAS3T1JfEmX8bg3b_m2bctfQvqmIAm9n9d8Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News-en.vue?macro=true";
import { default as index8jOMqdYJEADFRr2f6URIFSgpBf9HNq_tmAyTdJpXC2kMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhDetailInf/index.vue?macro=true";
import { default as detail_emsDoKAnNTzS_K__XVumK6sfeSkDgscB0vOxTN_KVgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail.vue?macro=true";
import { default as index_45en3QbdyerzMUpnyxK6a7xZcmUsWcyp4GlOylH3BEeUM1cMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-en.vue?macro=true";
import { default as update_45pwdHVehAYyM_bQv3AZFnPuYy_1U2i1Z_PhNjOybK1_CS2MMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-pwd.vue?macro=true";
import { default as users_45fansDQNA2P5xoxTAXoQTefpmDYC3TpTW7_dXDQgyF1jJW28Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-fans.vue?macro=true";
import { default as letterInfoewDPMJdzoSoPIEyWNAmBP1yppMs_zH4F1wTA2M8u064Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letterInfo.vue?macro=true";
import { default as nepconjpFdy4J7YCwKvmtDfxbDHWmGs8CRgm8GizZjtWGhWwQMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/formData/nepcon.ts?macro=true";
import { default as index_45seozunud_pMecXloHUNNqMI_rr3gP_gBqdnx9CtzmdpQLwMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-seo.vue?macro=true";
import { default as periodical_newLrJv5sCqRi_WfVfeBuaapJx0yf8Mhd2pjtpc2YxygVIMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical_new.vue?macro=true";
import { default as periodicalLista_iDS4bnA5p208wMtJOCZQAq3F_SnT6UlNMAtW2pGXsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodicalList.vue?macro=true";
import { default as fair_45followmSmNSdxVqM1hjRY5oCzju1BtQi0ltR1t8fx03OgmU6sMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-follow.vue?macro=true";
import { default as fair_45remind7RY5ULDJ0KWUHbIEGsxv84AXrDKLJuhZi2yfdKB7tXsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-remind.vue?macro=true";
import { default as industry_45mylqGprPqXwj0ceRKFUAnEDdv20QleW2mA343csJ_oxd4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/industry-my.vue?macro=true";
import { default as news_45followsNXeHLvUH3gMJ0hsQ9jB8O2JMHYnWGVVrI4nYLU699oMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-follow.vue?macro=true";
import { default as update_45infog_bcsnd1o1z0_rSj3DRFTpsN7372EAHzx7kSIo2rC04Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-info.vue?macro=true";
import { default as users_45followa8xow4ZW_eoQebWP8efbLTN1Ttc6t53GPdQWxjRsKBEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-follow.vue?macro=true";
import { default as _91id_93E6fNG_uu5NBkg_BbES3S6GPlUCoD9e_QPiktFPr80c0Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit/[id].vue?macro=true";
import { default as visitor_45edittgBWYUDecTrt2MBJ1fgs6IyhWKgUarxHGmJks1_8nscMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit.vue?macro=true";
import { default as NewsWbQd3M9_3i0v7EHeY9XVMG6QQkz3nqRCi11lZBaOQNQMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/News.vue?macro=true";
import { default as DetailsdzyFQpNlV2pBxqL6V4EjW2HGhlrtXSakn78S12lXqogMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details.vue?macro=true";
import { default as cardB_ZNnM9FG8zMvOi9522IBtXqxEadKXuWYVttQLZ8P6gMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/components/card.vue?macro=true";
import { default as boothE80ctJvgdJESHvu_a_BUUdvPzl1cPnaFlKrEG_fJlxoMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth.vue?macro=true";
import { default as RouteSCrNTRt4CCE64d_iOwrdH_fBhQdfpCa4zT26GvGfpS4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/Route.vue?macro=true";
import { default as detail_45enP2ZaGUxKmnMNBJmopSILJSydprDzlxmoT2nsbtBIJ4EMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail-en.vue?macro=true";
import { default as periodical_45myGmdHZe3fFrJGjiB_PcGR_CFrRgK7akv_q5uUe0uT_l8Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/periodical-my.vue?macro=true";
import { default as exponewsUQ7SmGfmo6NcUkuFb_wWsu_W8tK_RdkqyTzGBCkWlvQMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/exponews.vue?macro=true";
import { default as Poster9TUP7fVpZ2CUa36GGIPbdmxTRSkSqiXSqDeqkLr7c8wMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/components/Poster.vue?macro=true";
import { default as PayJmkkVn5sE1dKpQhGwiAAwMxYst7nXlLq6JHRdaYMpNsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/components/Pay.vue?macro=true";
import { default as booth1p4RcvwxfdWyNyWv8tAXlsj6esRS_ZDtcfYgRXrHgISoMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth1.vue?macro=true";
import { default as poster9xMEjanRbV3j0_r_81XpIte1IAJ_xU0NaaLOO8ifX6cMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/poster.vue?macro=true";
import { default as Cooperationv8NEqDyS3_UuPw9TNFhv1_4BShDVrCFJbYiEkua2FeUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/cooperation/Cooperation.vue?macro=true";
import { default as invoiceIYw7ujnS82njXZMmVI_Qfkp3cO5r2RpZYwLKhQsaOcQMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/invoice.vue?macro=true";
import { default as newItemvkiSSfILuWUYbjoQ7CXUy3crajZCp1lB9V87BY3_UXYMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newItem.vue?macro=true";
import { default as subsidyj9un57vDA7HgHpf2BsrE9_n2Q57jCjkt5CSKom7xEyYMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/subsidy.vue?macro=true";
import { default as detail1_45seoU4HGBPJOsQCHMgXdKBedV3e5Ks0QqAK5967k_zJJV_cMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail1-seo.vue?macro=true";
import { default as EveFairYIPip9L4rMZDniS4MECDJMI5_PMYlqrB6pzPYcdYKl4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/EveFair.vue?macro=true";
import { default as Details_45enMswICZx84pz0NlXeH2ukyi2W1CPjXE3QgVMjAMGajHEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details-en.vue?macro=true";
import { default as FairItemyDRlDHcCbn5QEYbqop2soTfpchKr8JMGrGTr4eRLdxgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/FairItem.vue?macro=true";
import { default as NewsListUTsFzYRwkenyEI_lpJccDUz0ySodd8PMRGUVkJI8lWIMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/NewsList.vue?macro=true";
import { default as NewsItemrdNNO2eh09SM1iON4X9Sn9hgHExLi4hKEdejv0UICOsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/NewsItem.vue?macro=true";
import { default as newDetailJTIOyL9_0CN_JwGZEXTEGkmge4SsUCUNo4bpsH1FUIIMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newDetail.vue?macro=true";
import { default as NewsItem2pfU7qE6K3U5tNQyKPmQ4KPTqWyMRKfnkfac_PQ2NidUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/NewsItem2.vue?macro=true";
import { default as orderInfozYTksO4wm2HtAMhJdIQCqO99ZijAoz4Kj_5jagyiO3UMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/orderInfo.vue?macro=true";
import { default as evaluationhkRADj1ggLjUNcfm97Fijmj1Om8Ja8ElBgrMdyoaTw4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/evaluation.vue?macro=true";
import { default as rightFloatGK9nWWfbdVA1a9i9JDXkJjs17u36tH6hOEs5RN8tk0sMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/rightFloat.vue?macro=true";
import { default as ServerStepX3GZt2S5DsPO7WWy1SJ5nCehcSbzvqIN4EaU5UbTiMMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/ServerStep.vue?macro=true";
import { default as RelatedNew6TzN4oAr3MRgelRRBV0Z8_E5sCG4Viv1uYY9J7TL9GEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/RelatedNew.vue?macro=true";
import { default as detailTopBg4WxH_uX_5__anZK8gUmoG84C_jx0f_Xs8zkqJrIOjmMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/detailTopBg.vue?macro=true";
import { default as FairItemSeoBbhj0MBl_U3QO3lF_veKw4I_p9RVJeqlVQgiQELo_UEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/FairItemSeo.vue?macro=true";
import { default as goodsDetailszyLU7NcTh22_EKR937WNZqH6nlvzGCCA7wCqwM3MkMMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/goodsDetail.vue?macro=true";
import { default as myUploadnsjDEDla7KnGPUIaxU1GNPR_VaQ8sUA4_Un3Uq_fMOEMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/myUpload.vue?macro=true";
import { default as VisaItem6ULx_Ei0nqsqJFeoOMbdLlgV9hSf_1I3jbcKH91L5GgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaItem.vue?macro=true";
import { default as resourceViewnPia2fhL0PLsXmb7aT_3_cGL4hkQLh5SoCd4NTR7kwgMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/resourceView.vue?macro=true";
import { default as RepaymentlMnC4Jj1o8gqxhxuv85CfhhDqoGCeQvyk96AmBQfeTsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/Repayment.vue?macro=true";
import { default as dialogSubsidy897UbPt5iXDbg6v1ZmYJc3dUJDz9wJXijN1w2fA0IKkMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/dialogSubsidy.vue?macro=true";
import { default as ExpoCardEnt7UC1MeWwPmFOKmV6lGXpItir4Dzc__4FUxvhRBxChcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/ExpoCardEn.vue?macro=true";
import { default as GetInvoicey0qhaQpywN4wwuAyncPK9zko08jvBwg4RF2lrUiVeOoMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/GetInvoice.vue?macro=true";
import { default as TicketItem9HrFCMfJqBhi2tA_6O1S3IidIkwZI2acUg_380fBWgcMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/TicketItem.vue?macro=true";
import { default as LookInvoicerz_AhMhqHuFEZ10U2PM2PJmxNrJtVJWe5pjrwP_IT0IMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/LookInvoice.vue?macro=true";
import { default as VisaRepaymentTTON3pF0aWVJk3xx2Htl8beTWNIt_b_DfEJqiQqJZmIMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaRepayment.vue?macro=true";
import { default as IndustryCardEnrEODlkX3yyyCXeJSDsl9XrAoofU_5E51gFXhBlzY7JUMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustryCardEn.vue?macro=true";
import { default as IndustrySubPopover9b3EjOZJ6ZbZMfh_6sICKZqCLOeLS2IY2M__z_kzHYsMeta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustrySubPopover.vue?macro=true";
import { default as visa_45_91visaAreaId_93_45_91areaId_93_45_91type_93_45_91bizType_93_45_91page_93_Lc_Y9aVjED8aSLu30o4a3bRha6CUmYHrVgMOkaBpj4Meta } from "/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/visa-[visaAreaId]-[areaId]-[type]-[bizType]-[page].vue?macro=true";
export default [
  {
    name: "home-Home___en",
    path: "/en/home/Home",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home.vue")
  },
  {
    name: "home-Home___zh",
    path: "/home/Home",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home.vue")
  },
  {
    name: "home-Home___cn",
    path: "/cn/home/Home",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home.vue")
  },
  {
    name: "visa-id___en",
    path: "/en/visa/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[id].vue")
  },
  {
    name: "visa-id___zh",
    path: "/visa/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[id].vue")
  },
  {
    name: "visa-id___cn",
    path: "/cn/visa/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[id].vue")
  },
  {
    name: "wiki-list___en",
    path: "/en/wiki/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/list.vue")
  },
  {
    name: "wiki-list___zh",
    path: "/wiki/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/list.vue")
  },
  {
    name: "wiki-list___cn",
    path: "/cn/wiki/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/list.vue")
  },
  {
    name: "fair-player___en",
    path: "/en/fair/player",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/player.ts")
  },
  {
    name: "fair-player___zh",
    path: "/fair/player",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/player.ts")
  },
  {
    name: "fair-player___cn",
    path: "/cn/fair/player",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/player.ts")
  },
  {
    name: "news-helper___en",
    path: "/en/news/helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/helper.ts")
  },
  {
    name: "news-helper___zh",
    path: "/news/helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/helper.ts")
  },
  {
    name: "news-helper___cn",
    path: "/cn/news/helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/helper.ts")
  },
  {
    name: "pay-Result___en",
    path: "/en/pay/Result",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result.vue")
  },
  {
    name: "pay-Result___zh",
    path: "/pay/Result",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result.vue")
  },
  {
    name: "pay-Result___cn",
    path: "/cn/pay/Result",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result.vue")
  },
  {
    name: "trip___en",
    path: "/en/trip",
    meta: indexHoh4mAHqmjYEgHdwnfBtdugpsefUo3I9yeqzzxSmmXgMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/trip/index.vue")
  },
  {
    name: "trip___zh",
    path: "/trip",
    meta: indexHoh4mAHqmjYEgHdwnfBtdugpsefUo3I9yeqzzxSmmXgMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/trip/index.vue")
  },
  {
    name: "trip___cn",
    path: "/cn/trip",
    meta: indexHoh4mAHqmjYEgHdwnfBtdugpsefUo3I9yeqzzxSmmXgMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/trip/index.vue")
  },
  {
    name: "wiki___en",
    path: "/en/wiki",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___zh",
    path: "/wiki",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/index.vue")
  },
  {
    name: "wiki___cn",
    path: "/cn/wiki",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/index.vue")
  },
  {
    name: "booth-helper___en",
    path: "/en/booth/helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/helper.ts")
  },
  {
    name: "booth-helper___zh",
    path: "/booth/helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/helper.ts")
  },
  {
    name: "booth-helper___cn",
    path: "/cn/booth/helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/helper.ts")
  },
  {
    name: "booth___en",
    path: "/en/booth",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/index.vue")
  },
  {
    name: "booth___zh",
    path: "/booth",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/index.vue")
  },
  {
    name: "booth___cn",
    path: "/cn/booth",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/index.vue")
  },
  {
    name: "fair-service___en",
    path: "/en/fair/service",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/service.ts")
  },
  {
    name: "fair-service___zh",
    path: "/fair/service",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/service.ts")
  },
  {
    name: "fair-service___cn",
    path: "/cn/fair/service",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/service.ts")
  },
  {
    name: "fair-ticket___en",
    path: "/en/fair/ticket",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket.vue"),
    children: [
  {
    name: "fair-ticket-helper___en",
    path: "helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/helper.ts")
  },
  {
    name: "fair-ticket-ticket___en",
    path: "ticket",
    meta: ticketHuXVe5gyYzUO01iI62IHC3sfGbEEPcf4VQxnea9yZVsMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket.vue")
  },
  {
    name: "fair-ticket-ticket-en___en",
    path: "ticket-en",
    meta: ticket_45ensnvNi4Hesys_U1QVGhnsXBae_06OFePdUYFoxrxM7oUMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket-en.vue")
  },
  {
    name: "fair-ticket-formData-nepcon___en",
    path: "formData/nepcon",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/formData/nepcon.ts")
  },
  {
    name: "fair-ticket-components-MapDialog___en",
    path: "components/MapDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MapDialog.vue")
  },
  {
    name: "fair-ticket-components-Repayment___en",
    path: "components/Repayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/Repayment.vue")
  },
  {
    name: "fair-ticket-components-TicketSteps___en",
    path: "components/TicketSteps",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSteps.vue")
  },
  {
    name: "fair-ticket-components-FairBasicInfo___en",
    path: "components/FairBasicInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfo.vue")
  },
  {
    name: "fair-ticket-components-FairTimeStatus___en",
    path: "components/FairTimeStatus",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairTimeStatus.vue")
  },
  {
    name: "fair-ticket-components-PaymentSection___en",
    path: "components/PaymentSection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PaymentSection.vue")
  },
  {
    name: "fair-ticket-components-CareerTicketTip___en",
    path: "components/CareerTicketTip",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CareerTicketTip.vue")
  },
  {
    name: "fair-ticket-components-FairCoverQrcode___en",
    path: "components/FairCoverQrcode",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairCoverQrcode.vue")
  },
  {
    name: "fair-ticket-components-FairNameDisplay___en",
    path: "components/FairNameDisplay",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairNameDisplay.vue")
  },
  {
    name: "fair-ticket-components-NameInputDialog___en",
    path: "components/NameInputDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/NameInputDialog.vue")
  },
  {
    name: "fair-ticket-components-TicketSelection___en",
    path: "components/TicketSelection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSelection.vue")
  },
  {
    name: "fair-ticket-components-FairImageGallery___en",
    path: "components/FairImageGallery",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairImageGallery.vue")
  },
  {
    name: "fair-ticket-components-FairIntroduction___en",
    path: "components/FairIntroduction",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairIntroduction.vue")
  },
  {
    name: "fair-ticket-components-IndustryFairList___en",
    path: "components/IndustryFairList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/IndustryFairList.vue")
  },
  {
    name: "fair-ticket-components-TicketBreadcrumb___en",
    path: "components/TicketBreadcrumb",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketBreadcrumb.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketInfoCard___en",
    path: "componentsEn/TicketInfoCard",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketInfoCard.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketTypeCard___en",
    path: "componentsEn/TicketTypeCard",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeCard.vue")
  },
  {
    name: "fair-ticket-components-MiniProgramDialog___en",
    path: "components/MiniProgramDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MiniProgramDialog.vue")
  },
  {
    name: "fair-ticket-components-RepeatOrderDialog___en",
    path: "components/RepeatOrderDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/RepeatOrderDialog.vue")
  },
  {
    name: "fair-ticket-components-VisitorFormDialog___en",
    path: "components/VisitorFormDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorFormDialog.vue")
  },
  {
    name: "fair-ticket-components-VisitorManagement___en",
    path: "components/VisitorManagement",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorManagement.vue")
  },
  {
    name: "fair-ticket-components-SameFairExhibition___en",
    path: "components/SameFairExhibition",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/SameFairExhibition.vue")
  },
  {
    name: "fair-ticket-components-TicketRightSidebar___en",
    path: "components/TicketRightSidebar",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketRightSidebar.vue")
  },
  {
    name: "fair-ticket-components-ElectronicTicketTip___en",
    path: "components/ElectronicTicketTip",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/ElectronicTicketTip.vue")
  },
  {
    name: "fair-ticket-components-TicketPurchaseGuide___en",
    path: "components/TicketPurchaseGuide",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketPurchaseGuide.vue")
  },
  {
    name: "fair-ticket-componentsEn-VisitorManagement___en",
    path: "componentsEn/VisitorManagement",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/VisitorManagement.vue")
  },
  {
    name: "fair-ticket-components-CompanyCertification___en",
    path: "components/CompanyCertification",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyCertification.vue")
  },
  {
    name: "fair-ticket-components-FairBasicInfoDetails___en",
    path: "components/FairBasicInfoDetails",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfoDetails.vue")
  },
  {
    name: "fair-ticket-components-PrivacySubmitSection___en",
    path: "components/PrivacySubmitSection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PrivacySubmitSection.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketTypeSelector___en",
    path: "componentsEn/TicketTypeSelector",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeSelector.vue")
  },
  {
    name: "fair-ticket-components-BusinessLicenseUpload___en",
    path: "components/BusinessLicenseUpload",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/BusinessLicenseUpload.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketPurchaseGuide___en",
    path: "componentsEn/TicketPurchaseGuide",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketPurchaseGuide.vue")
  },
  {
    name: "fair-ticket-components-CompanyPersonalSelector___en",
    path: "components/CompanyPersonalSelector",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyPersonalSelector.vue")
  },
  {
    name: "fair-ticket-componentsEn-UploadAndProductInput___en",
    path: "componentsEn/UploadAndProductInput",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/UploadAndProductInput.vue")
  }
]
  },
  {
    name: "fair-ticket___zh",
    path: "/fair/ticket",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket.vue"),
    children: [
  {
    name: "fair-ticket-helper___zh",
    path: "helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/helper.ts")
  },
  {
    name: "fair-ticket-ticket___zh",
    path: "ticket",
    meta: ticketHuXVe5gyYzUO01iI62IHC3sfGbEEPcf4VQxnea9yZVsMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket.vue")
  },
  {
    name: "fair-ticket-ticket-en___zh",
    path: "ticket-en",
    meta: ticket_45ensnvNi4Hesys_U1QVGhnsXBae_06OFePdUYFoxrxM7oUMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket-en.vue")
  },
  {
    name: "fair-ticket-formData-nepcon___zh",
    path: "formData/nepcon",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/formData/nepcon.ts")
  },
  {
    name: "fair-ticket-components-MapDialog___zh",
    path: "components/MapDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MapDialog.vue")
  },
  {
    name: "fair-ticket-components-Repayment___zh",
    path: "components/Repayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/Repayment.vue")
  },
  {
    name: "fair-ticket-components-TicketSteps___zh",
    path: "components/TicketSteps",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSteps.vue")
  },
  {
    name: "fair-ticket-components-FairBasicInfo___zh",
    path: "components/FairBasicInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfo.vue")
  },
  {
    name: "fair-ticket-components-FairTimeStatus___zh",
    path: "components/FairTimeStatus",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairTimeStatus.vue")
  },
  {
    name: "fair-ticket-components-PaymentSection___zh",
    path: "components/PaymentSection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PaymentSection.vue")
  },
  {
    name: "fair-ticket-components-CareerTicketTip___zh",
    path: "components/CareerTicketTip",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CareerTicketTip.vue")
  },
  {
    name: "fair-ticket-components-FairCoverQrcode___zh",
    path: "components/FairCoverQrcode",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairCoverQrcode.vue")
  },
  {
    name: "fair-ticket-components-FairNameDisplay___zh",
    path: "components/FairNameDisplay",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairNameDisplay.vue")
  },
  {
    name: "fair-ticket-components-NameInputDialog___zh",
    path: "components/NameInputDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/NameInputDialog.vue")
  },
  {
    name: "fair-ticket-components-TicketSelection___zh",
    path: "components/TicketSelection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSelection.vue")
  },
  {
    name: "fair-ticket-components-FairImageGallery___zh",
    path: "components/FairImageGallery",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairImageGallery.vue")
  },
  {
    name: "fair-ticket-components-FairIntroduction___zh",
    path: "components/FairIntroduction",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairIntroduction.vue")
  },
  {
    name: "fair-ticket-components-IndustryFairList___zh",
    path: "components/IndustryFairList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/IndustryFairList.vue")
  },
  {
    name: "fair-ticket-components-TicketBreadcrumb___zh",
    path: "components/TicketBreadcrumb",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketBreadcrumb.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketInfoCard___zh",
    path: "componentsEn/TicketInfoCard",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketInfoCard.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketTypeCard___zh",
    path: "componentsEn/TicketTypeCard",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeCard.vue")
  },
  {
    name: "fair-ticket-components-MiniProgramDialog___zh",
    path: "components/MiniProgramDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MiniProgramDialog.vue")
  },
  {
    name: "fair-ticket-components-RepeatOrderDialog___zh",
    path: "components/RepeatOrderDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/RepeatOrderDialog.vue")
  },
  {
    name: "fair-ticket-components-VisitorFormDialog___zh",
    path: "components/VisitorFormDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorFormDialog.vue")
  },
  {
    name: "fair-ticket-components-VisitorManagement___zh",
    path: "components/VisitorManagement",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorManagement.vue")
  },
  {
    name: "fair-ticket-components-SameFairExhibition___zh",
    path: "components/SameFairExhibition",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/SameFairExhibition.vue")
  },
  {
    name: "fair-ticket-components-TicketRightSidebar___zh",
    path: "components/TicketRightSidebar",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketRightSidebar.vue")
  },
  {
    name: "fair-ticket-components-ElectronicTicketTip___zh",
    path: "components/ElectronicTicketTip",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/ElectronicTicketTip.vue")
  },
  {
    name: "fair-ticket-components-TicketPurchaseGuide___zh",
    path: "components/TicketPurchaseGuide",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketPurchaseGuide.vue")
  },
  {
    name: "fair-ticket-componentsEn-VisitorManagement___zh",
    path: "componentsEn/VisitorManagement",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/VisitorManagement.vue")
  },
  {
    name: "fair-ticket-components-CompanyCertification___zh",
    path: "components/CompanyCertification",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyCertification.vue")
  },
  {
    name: "fair-ticket-components-FairBasicInfoDetails___zh",
    path: "components/FairBasicInfoDetails",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfoDetails.vue")
  },
  {
    name: "fair-ticket-components-PrivacySubmitSection___zh",
    path: "components/PrivacySubmitSection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PrivacySubmitSection.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketTypeSelector___zh",
    path: "componentsEn/TicketTypeSelector",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeSelector.vue")
  },
  {
    name: "fair-ticket-components-BusinessLicenseUpload___zh",
    path: "components/BusinessLicenseUpload",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/BusinessLicenseUpload.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketPurchaseGuide___zh",
    path: "componentsEn/TicketPurchaseGuide",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketPurchaseGuide.vue")
  },
  {
    name: "fair-ticket-components-CompanyPersonalSelector___zh",
    path: "components/CompanyPersonalSelector",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyPersonalSelector.vue")
  },
  {
    name: "fair-ticket-componentsEn-UploadAndProductInput___zh",
    path: "componentsEn/UploadAndProductInput",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/UploadAndProductInput.vue")
  }
]
  },
  {
    name: "fair-ticket___cn",
    path: "/cn/fair/ticket",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket.vue"),
    children: [
  {
    name: "fair-ticket-helper___cn",
    path: "helper",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/helper.ts")
  },
  {
    name: "fair-ticket-ticket___cn",
    path: "ticket",
    meta: ticketHuXVe5gyYzUO01iI62IHC3sfGbEEPcf4VQxnea9yZVsMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket.vue")
  },
  {
    name: "fair-ticket-ticket-en___cn",
    path: "ticket-en",
    meta: ticket_45ensnvNi4Hesys_U1QVGhnsXBae_06OFePdUYFoxrxM7oUMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/ticket-en.vue")
  },
  {
    name: "fair-ticket-formData-nepcon___cn",
    path: "formData/nepcon",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/formData/nepcon.ts")
  },
  {
    name: "fair-ticket-components-MapDialog___cn",
    path: "components/MapDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MapDialog.vue")
  },
  {
    name: "fair-ticket-components-Repayment___cn",
    path: "components/Repayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/Repayment.vue")
  },
  {
    name: "fair-ticket-components-TicketSteps___cn",
    path: "components/TicketSteps",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSteps.vue")
  },
  {
    name: "fair-ticket-components-FairBasicInfo___cn",
    path: "components/FairBasicInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfo.vue")
  },
  {
    name: "fair-ticket-components-FairTimeStatus___cn",
    path: "components/FairTimeStatus",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairTimeStatus.vue")
  },
  {
    name: "fair-ticket-components-PaymentSection___cn",
    path: "components/PaymentSection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PaymentSection.vue")
  },
  {
    name: "fair-ticket-components-CareerTicketTip___cn",
    path: "components/CareerTicketTip",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CareerTicketTip.vue")
  },
  {
    name: "fair-ticket-components-FairCoverQrcode___cn",
    path: "components/FairCoverQrcode",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairCoverQrcode.vue")
  },
  {
    name: "fair-ticket-components-FairNameDisplay___cn",
    path: "components/FairNameDisplay",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairNameDisplay.vue")
  },
  {
    name: "fair-ticket-components-NameInputDialog___cn",
    path: "components/NameInputDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/NameInputDialog.vue")
  },
  {
    name: "fair-ticket-components-TicketSelection___cn",
    path: "components/TicketSelection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketSelection.vue")
  },
  {
    name: "fair-ticket-components-FairImageGallery___cn",
    path: "components/FairImageGallery",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairImageGallery.vue")
  },
  {
    name: "fair-ticket-components-FairIntroduction___cn",
    path: "components/FairIntroduction",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairIntroduction.vue")
  },
  {
    name: "fair-ticket-components-IndustryFairList___cn",
    path: "components/IndustryFairList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/IndustryFairList.vue")
  },
  {
    name: "fair-ticket-components-TicketBreadcrumb___cn",
    path: "components/TicketBreadcrumb",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketBreadcrumb.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketInfoCard___cn",
    path: "componentsEn/TicketInfoCard",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketInfoCard.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketTypeCard___cn",
    path: "componentsEn/TicketTypeCard",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeCard.vue")
  },
  {
    name: "fair-ticket-components-MiniProgramDialog___cn",
    path: "components/MiniProgramDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/MiniProgramDialog.vue")
  },
  {
    name: "fair-ticket-components-RepeatOrderDialog___cn",
    path: "components/RepeatOrderDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/RepeatOrderDialog.vue")
  },
  {
    name: "fair-ticket-components-VisitorFormDialog___cn",
    path: "components/VisitorFormDialog",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorFormDialog.vue")
  },
  {
    name: "fair-ticket-components-VisitorManagement___cn",
    path: "components/VisitorManagement",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/VisitorManagement.vue")
  },
  {
    name: "fair-ticket-components-SameFairExhibition___cn",
    path: "components/SameFairExhibition",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/SameFairExhibition.vue")
  },
  {
    name: "fair-ticket-components-TicketRightSidebar___cn",
    path: "components/TicketRightSidebar",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketRightSidebar.vue")
  },
  {
    name: "fair-ticket-components-ElectronicTicketTip___cn",
    path: "components/ElectronicTicketTip",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/ElectronicTicketTip.vue")
  },
  {
    name: "fair-ticket-components-TicketPurchaseGuide___cn",
    path: "components/TicketPurchaseGuide",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/TicketPurchaseGuide.vue")
  },
  {
    name: "fair-ticket-componentsEn-VisitorManagement___cn",
    path: "componentsEn/VisitorManagement",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/VisitorManagement.vue")
  },
  {
    name: "fair-ticket-components-CompanyCertification___cn",
    path: "components/CompanyCertification",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyCertification.vue")
  },
  {
    name: "fair-ticket-components-FairBasicInfoDetails___cn",
    path: "components/FairBasicInfoDetails",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/FairBasicInfoDetails.vue")
  },
  {
    name: "fair-ticket-components-PrivacySubmitSection___cn",
    path: "components/PrivacySubmitSection",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/PrivacySubmitSection.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketTypeSelector___cn",
    path: "componentsEn/TicketTypeSelector",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketTypeSelector.vue")
  },
  {
    name: "fair-ticket-components-BusinessLicenseUpload___cn",
    path: "components/BusinessLicenseUpload",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/BusinessLicenseUpload.vue")
  },
  {
    name: "fair-ticket-componentsEn-TicketPurchaseGuide___cn",
    path: "componentsEn/TicketPurchaseGuide",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/TicketPurchaseGuide.vue")
  },
  {
    name: "fair-ticket-components-CompanyPersonalSelector___cn",
    path: "components/CompanyPersonalSelector",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/components/CompanyPersonalSelector.vue")
  },
  {
    name: "fair-ticket-componentsEn-UploadAndProductInput___cn",
    path: "componentsEn/UploadAndProductInput",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket/componentsEn/UploadAndProductInput.vue")
  }
]
  },
  {
    name: "fair-top100___en",
    path: "/en/fair/top100",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/top100.vue")
  },
  {
    name: "fair-top100___zh",
    path: "/fair/top100",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/top100.vue")
  },
  {
    name: "fair-top100___cn",
    path: "/cn/fair/top100",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/top100.vue")
  },
  {
    name: "fair-topData___en",
    path: "/en/fair/topData",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/topData.ts")
  },
  {
    name: "fair-topData___zh",
    path: "/fair/topData",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/topData.ts")
  },
  {
    name: "fair-topData___cn",
    path: "/cn/fair/topData",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/topData.ts")
  },
  {
    name: "login___en",
    path: "/en/login",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/login/index.vue")
  },
  {
    name: "login___zh",
    path: "/login",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/login/index.vue")
  },
  {
    name: "login___cn",
    path: "/cn/login",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/login/index.vue")
  },
  {
    name: "terms___en",
    path: "/en/terms",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/terms/index.vue")
  },
  {
    name: "terms___zh",
    path: "/terms",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/terms/index.vue")
  },
  {
    name: "terms___cn",
    path: "/cn/terms",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/terms/index.vue")
  },
  {
    name: "wiki-detail___en",
    path: "/en/wiki/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/detail.vue")
  },
  {
    name: "wiki-detail___zh",
    path: "/wiki/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/detail.vue")
  },
  {
    name: "wiki-detail___cn",
    path: "/cn/wiki/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/wiki/detail.vue")
  },
  {
    name: "company-id___en",
    path: "/en/company/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/[id].vue")
  },
  {
    name: "company-id___zh",
    path: "/company/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/[id].vue")
  },
  {
    name: "company-id___cn",
    path: "/cn/company/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/[id].vue")
  },
  {
    name: "company-list___en",
    path: "/en/company/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/list.vue")
  },
  {
    name: "company-list___zh",
    path: "/company/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/list.vue")
  },
  {
    name: "company-list___cn",
    path: "/cn/company/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/list.vue")
  },
  {
    name: "home-Home-en___en",
    path: "/en/home/Home-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home-en.vue")
  },
  {
    name: "home-Home-en___zh",
    path: "/home/Home-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home-en.vue")
  },
  {
    name: "home-Home-en___cn",
    path: "/cn/home/Home-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/Home-en.vue")
  },
  {
    name: "manager-auth___en",
    path: "/en/manager/auth",
    meta: authkkxPYEcxVZJM1nmJ1VyrqhTzBM49IyXdlI02A_7dZDIMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/auth.vue")
  },
  {
    name: "manager-auth___zh",
    path: "/manager/auth",
    meta: authkkxPYEcxVZJM1nmJ1VyrqhTzBM49IyXdlI02A_7dZDIMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/auth.vue")
  },
  {
    name: "manager-auth___cn",
    path: "/cn/manager/auth",
    meta: authkkxPYEcxVZJM1nmJ1VyrqhTzBM49IyXdlI02A_7dZDIMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/auth.vue")
  },
  {
    name: "manager-visa___en",
    path: "/en/manager/visa",
    meta: visaq8uXgBlzWewt_GmMW7I15H0S6EHvp98s4TUb3EPjAa4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visa.vue")
  },
  {
    name: "manager-visa___zh",
    path: "/manager/visa",
    meta: visaq8uXgBlzWewt_GmMW7I15H0S6EHvp98s4TUb3EPjAa4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visa.vue")
  },
  {
    name: "manager-visa___cn",
    path: "/cn/manager/visa",
    meta: visaq8uXgBlzWewt_GmMW7I15H0S6EHvp98s4TUb3EPjAa4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visa.vue")
  },
  {
    name: "system-error___en",
    path: "/en/system/error",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/error.vue")
  },
  {
    name: "system-error___zh",
    path: "/system/error",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/error.vue")
  },
  {
    name: "system-error___cn",
    path: "/cn/system/error",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/error.vue")
  },
  {
    name: "system___en",
    path: "/en/system",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/index.vue")
  },
  {
    name: "system___zh",
    path: "/system",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/index.vue")
  },
  {
    name: "system___cn",
    path: "/cn/system",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/system/index.vue")
  },
  {
    name: "center-Center___en",
    path: "/en/center/Center",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center.vue")
  },
  {
    name: "center-Center___zh",
    path: "/center/Center",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center.vue")
  },
  {
    name: "center-Center___cn",
    path: "/cn/center/Center",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center.vue")
  },
  {
    name: "fair-proxyExh___en",
    path: "/en/fair/proxyExh",
    meta: proxyExhisE6pqC1feL_a6mW3wc233IGXuL51ajVJ0iD8N9p6RsMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/proxyExh.vue")
  },
  {
    name: "fair-proxyExh___zh",
    path: "/fair/proxyExh",
    meta: proxyExhisE6pqC1feL_a6mW3wc233IGXuL51ajVJ0iD8N9p6RsMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/proxyExh.vue")
  },
  {
    name: "fair-proxyExh___cn",
    path: "/cn/fair/proxyExh",
    meta: proxyExhisE6pqC1feL_a6mW3wc233IGXuL51ajVJ0iD8N9p6RsMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/proxyExh.vue")
  },
  {
    name: "manager___en",
    path: "/en/manager",
    meta: indexEpqcoV67TaE1TP59ri_mn9dxAU6nBqfTTIhQS6y5JZ4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/index.vue")
  },
  {
    name: "manager___zh",
    path: "/manager",
    meta: indexEpqcoV67TaE1TP59ri_mn9dxAU6nBqfTTIhQS6y5JZ4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/index.vue")
  },
  {
    name: "manager___cn",
    path: "/cn/manager",
    meta: indexEpqcoV67TaE1TP59ri_mn9dxAU6nBqfTTIhQS6y5JZ4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/index.vue")
  },
  {
    name: "pay-Result-en___en",
    path: "/en/pay/Result-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result-en.vue")
  },
  {
    name: "pay-Result-en___zh",
    path: "/pay/Result-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result-en.vue")
  },
  {
    name: "pay-Result-en___cn",
    path: "/cn/pay/Result-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/Result-en.vue")
  },
  {
    name: "sitemap___en",
    path: "/en/sitemap",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/index.vue")
  },
  {
    name: "sitemap___zh",
    path: "/sitemap",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/index.vue")
  },
  {
    name: "sitemap___cn",
    path: "/cn/sitemap",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/index.vue")
  },
  {
    name: "special___en",
    path: "/en/special",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/special/index.vue")
  },
  {
    name: "special___zh",
    path: "/special",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/special/index.vue")
  },
  {
    name: "special___cn",
    path: "/cn/special",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/special/index.vue")
  },
  {
    name: "visa-status___en",
    path: "/en/visa/:status()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[status].vue")
  },
  {
    name: "visa-status___zh",
    path: "/visa/:status()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[status].vue")
  },
  {
    name: "visa-status___cn",
    path: "/cn/visa/:status()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/[status].vue")
  },
  {
    name: "center-Details___en",
    path: "/en/center/Details",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details.vue")
  },
  {
    name: "center-Details___zh",
    path: "/center/Details",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details.vue")
  },
  {
    name: "center-Details___cn",
    path: "/cn/center/Details",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details.vue")
  },
  {
    name: "company-detail___en",
    path: "/en/company/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/detail.vue")
  },
  {
    name: "company-detail___zh",
    path: "/company/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/detail.vue")
  },
  {
    name: "company-detail___cn",
    path: "/cn/company/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/detail.vue")
  },
  {
    name: "expouser___en",
    path: "/en/expouser",
    meta: index7PcBhuIUPS8oC4dUTqoC42DZrBN0tRdNzdXpyVOQj1AMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index.vue")
  },
  {
    name: "expouser___zh",
    path: "/expouser",
    meta: index7PcBhuIUPS8oC4dUTqoC42DZrBN0tRdNzdXpyVOQj1AMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index.vue")
  },
  {
    name: "expouser___cn",
    path: "/cn/expouser",
    meta: index7PcBhuIUPS8oC4dUTqoC42DZrBN0tRdNzdXpyVOQj1AMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index.vue")
  },
  {
    name: "home-data___en",
    path: "/en/home/data",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/data/index.ts")
  },
  {
    name: "home-data___zh",
    path: "/home/data",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/data/index.ts")
  },
  {
    name: "home-data___cn",
    path: "/cn/home/data",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/data/index.ts")
  },
  {
    name: "news-list-News___en",
    path: "/en/news/list/News",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News.vue")
  },
  {
    name: "news-list-News___zh",
    path: "/news/list/News",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News.vue")
  },
  {
    name: "news-list-News___cn",
    path: "/cn/news/list/News",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News.vue")
  },
  {
    name: "sitemap-letter___en",
    path: "/en/sitemap/letter",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letter.vue")
  },
  {
    name: "sitemap-letter___zh",
    path: "/sitemap/letter",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letter.vue")
  },
  {
    name: "sitemap-letter___cn",
    path: "/cn/sitemap/letter",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letter.vue")
  },
  {
    name: "visa-payResult___en",
    path: "/en/visa/payResult",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payResult.vue")
  },
  {
    name: "visa-payResult___zh",
    path: "/visa/payResult",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payResult.vue")
  },
  {
    name: "visa-payResult___cn",
    path: "/cn/visa/payResult",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payResult.vue")
  },
  {
    name: "about-advertise___en",
    path: "/en/about/advertise",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/advertise.vue")
  },
  {
    name: "about-advertise___zh",
    path: "/about/advertise",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/advertise.vue")
  },
  {
    name: "about-advertise___cn",
    path: "/cn/about/advertise",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/advertise.vue")
  },
  {
    name: "about-data___en",
    path: "/en/about/data",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/data/index.ts")
  },
  {
    name: "about-data___zh",
    path: "/about/data",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/data/index.ts")
  },
  {
    name: "about-data___cn",
    path: "/cn/about/data",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/data/index.ts")
  },
  {
    name: "community___en",
    path: "/en/community",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/community/index.vue")
  },
  {
    name: "community___zh",
    path: "/community",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/community/index.vue")
  },
  {
    name: "community___cn",
    path: "/cn/community",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/community/index.vue")
  },
  {
    name: "exhibitors-id___en",
    path: "/en/exhibitors/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhibitors/[id].vue")
  },
  {
    name: "exhibitors-id___zh",
    path: "/exhibitors/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhibitors/[id].vue")
  },
  {
    name: "exhibitors-id___cn",
    path: "/cn/exhibitors/:id()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhibitors/[id].vue")
  },
  {
    name: "fair-list___en",
    path: "/en/fair/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index.vue")
  },
  {
    name: "fair-list___zh",
    path: "/fair/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index.vue")
  },
  {
    name: "fair-list___cn",
    path: "/cn/fair/list",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index.vue")
  },
  {
    name: "fair-periodical___en",
    path: "/en/fair/periodical",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical.vue")
  },
  {
    name: "fair-periodical___zh",
    path: "/fair/periodical",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical.vue")
  },
  {
    name: "fair-periodical___cn",
    path: "/cn/fair/periodical",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical.vue")
  },
  {
    name: "fair-ticket_free___en",
    path: "/en/fair/ticket_free",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket_free.ts")
  },
  {
    name: "fair-ticket_free___zh",
    path: "/fair/ticket_free",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket_free.ts")
  },
  {
    name: "fair-ticket_free___cn",
    path: "/cn/fair/ticket_free",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/ticket_free.ts")
  },
  {
    name: "manager-fair-my___en",
    path: "/en/manager/fair-my",
    meta: fair_45myf8DGGkNUI_2Ud9Df1pWjvI8KZU2As7JtcCET0BeZCHMMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-my.vue")
  },
  {
    name: "manager-fair-my___zh",
    path: "/manager/fair-my",
    meta: fair_45myf8DGGkNUI_2Ud9Df1pWjvI8KZU2As7JtcCET0BeZCHMMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-my.vue")
  },
  {
    name: "manager-fair-my___cn",
    path: "/cn/manager/fair-my",
    meta: fair_45myf8DGGkNUI_2Ud9Df1pWjvI8KZU2As7JtcCET0BeZCHMMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-my.vue")
  },
  {
    name: "manager-news-my___en",
    path: "/en/manager/news-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-my.vue")
  },
  {
    name: "manager-news-my___zh",
    path: "/manager/news-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-my.vue")
  },
  {
    name: "manager-news-my___cn",
    path: "/cn/manager/news-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-my.vue")
  },
  {
    name: "manager-visitor___en",
    path: "/en/manager/visitor",
    meta: visitorG1zwiDgtlGyScttH4TdE46hLp7Iisb1ZJCRMxe9mLwkMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor.vue")
  },
  {
    name: "manager-visitor___zh",
    path: "/manager/visitor",
    meta: visitorG1zwiDgtlGyScttH4TdE46hLp7Iisb1ZJCRMxe9mLwkMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor.vue")
  },
  {
    name: "manager-visitor___cn",
    path: "/cn/manager/visitor",
    meta: visitorG1zwiDgtlGyScttH4TdE46hLp7Iisb1ZJCRMxe9mLwkMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor.vue")
  },
  {
    name: "center-Center-en___en",
    path: "/en/center/Center-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center-en.vue")
  },
  {
    name: "center-Center-en___zh",
    path: "/center/Center-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center-en.vue")
  },
  {
    name: "center-Center-en___cn",
    path: "/cn/center/Center-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Center-en.vue")
  },
  {
    name: "visa-payment-new___en",
    path: "/en/visa/payment-new",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payment-new.vue")
  },
  {
    name: "visa-payment-new___zh",
    path: "/visa/payment-new",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payment-new.vue")
  },
  {
    name: "visa-payment-new___cn",
    path: "/cn/visa/payment-new",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/payment-new.vue")
  },
  {
    name: "visa-submitOrder___en",
    path: "/en/visa/submitOrder",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/submitOrder.vue")
  },
  {
    name: "visa-submitOrder___zh",
    path: "/visa/submitOrder",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/submitOrder.vue")
  },
  {
    name: "visa-submitOrder___cn",
    path: "/cn/visa/submitOrder",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/submitOrder.vue")
  },
  {
    name: "about-index-nuxt3___en",
    path: "/en/about/index-nuxt3",
    meta: { ...(index_45nuxt3z2UZAba4iEps2rGAuqFGHgMNa_iypN8TTx7L_IyAI1YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/index-nuxt3.vue")
  },
  {
    name: "about-index-nuxt3___zh",
    path: "/about/index-nuxt3",
    meta: { ...(index_45nuxt3z2UZAba4iEps2rGAuqFGHgMNa_iypN8TTx7L_IyAI1YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/index-nuxt3.vue")
  },
  {
    name: "about-index-nuxt3___cn",
    path: "/cn/about/index-nuxt3",
    meta: { ...(index_45nuxt3z2UZAba4iEps2rGAuqFGHgMNa_iypN8TTx7L_IyAI1YMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/about/index-nuxt3.vue")
  },
  {
    name: "center-Details-en___en",
    path: "/en/center/Details-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details-en.vue")
  },
  {
    name: "center-Details-en___zh",
    path: "/center/Details-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details-en.vue")
  },
  {
    name: "center-Details-en___cn",
    path: "/cn/center/Details-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/center/Details-en.vue")
  },
  {
    name: "expouser-index-en___en",
    path: "/en/expouser/index-en",
    meta: index_45env_feM_i2e6ccoBQ_LXRU_udixKF_4ids3bKvVZYcvR4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index-en.vue")
  },
  {
    name: "expouser-index-en___zh",
    path: "/expouser/index-en",
    meta: index_45env_feM_i2e6ccoBQ_LXRU_udixKF_4ids3bKvVZYcvR4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index-en.vue")
  },
  {
    name: "expouser-index-en___cn",
    path: "/cn/expouser/index-en",
    meta: index_45env_feM_i2e6ccoBQ_LXRU_udixKF_4ids3bKvVZYcvR4Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/expouser/index-en.vue")
  },
  {
    name: "letter-letterInfo___en",
    path: "/en/letter/letterInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/letter/letterInfo.vue")
  },
  {
    name: "letter-letterInfo___zh",
    path: "/letter/letterInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/letter/letterInfo.vue")
  },
  {
    name: "letter-letterInfo___cn",
    path: "/cn/letter/letterInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/letter/letterInfo.vue")
  },
  {
    name: "manager-ticket-my___en",
    path: "/en/manager/ticket-my",
    meta: ticket_45my2hhF6dQbcpHLIeCaR5h1t_bSpd92SGApygZEc_v_n2YMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/ticket-my.vue")
  },
  {
    name: "manager-ticket-my___zh",
    path: "/manager/ticket-my",
    meta: ticket_45my2hhF6dQbcpHLIeCaR5h1t_bSpd92SGApygZEc_v_n2YMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/ticket-my.vue")
  },
  {
    name: "manager-ticket-my___cn",
    path: "/cn/manager/ticket-my",
    meta: ticket_45my2hhF6dQbcpHLIeCaR5h1t_bSpd92SGApygZEc_v_n2YMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/ticket-my.vue")
  },
  {
    name: "news-list-News-en___en",
    path: "/en/news/list/News-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News-en.vue")
  },
  {
    name: "news-list-News-en___zh",
    path: "/news/list/News-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News-en.vue")
  },
  {
    name: "news-list-News-en___cn",
    path: "/cn/news/list/News-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/list/News-en.vue")
  },
  {
    name: "exhDetailInf___en",
    path: "/en/exhDetailInf",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhDetailInf/index.vue")
  },
  {
    name: "exhDetailInf___zh",
    path: "/exhDetailInf",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhDetailInf/index.vue")
  },
  {
    name: "exhDetailInf___cn",
    path: "/cn/exhDetailInf",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/exhDetailInf/index.vue")
  },
  {
    name: "fair-detail-detail___en",
    path: "/en/fair/detail/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail.vue")
  },
  {
    name: "fair-detail-detail___zh",
    path: "/fair/detail/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail.vue")
  },
  {
    name: "fair-detail-detail___cn",
    path: "/cn/fair/detail/detail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail.vue")
  },
  {
    name: "fair-list-index-en___en",
    path: "/en/fair/list/index-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-en.vue")
  },
  {
    name: "fair-list-index-en___zh",
    path: "/fair/list/index-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-en.vue")
  },
  {
    name: "fair-list-index-en___cn",
    path: "/cn/fair/list/index-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-en.vue")
  },
  {
    name: "manager-update-pwd___en",
    path: "/en/manager/update-pwd",
    meta: update_45pwdHVehAYyM_bQv3AZFnPuYy_1U2i1Z_PhNjOybK1_CS2MMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-pwd.vue")
  },
  {
    name: "manager-update-pwd___zh",
    path: "/manager/update-pwd",
    meta: update_45pwdHVehAYyM_bQv3AZFnPuYy_1U2i1Z_PhNjOybK1_CS2MMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-pwd.vue")
  },
  {
    name: "manager-update-pwd___cn",
    path: "/cn/manager/update-pwd",
    meta: update_45pwdHVehAYyM_bQv3AZFnPuYy_1U2i1Z_PhNjOybK1_CS2MMeta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-pwd.vue")
  },
  {
    name: "manager-users-fans___en",
    path: "/en/manager/users-fans",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-fans.vue")
  },
  {
    name: "manager-users-fans___zh",
    path: "/manager/users-fans",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-fans.vue")
  },
  {
    name: "manager-users-fans___cn",
    path: "/cn/manager/users-fans",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-fans.vue")
  },
  {
    name: "sitemap-letterInfo___en",
    path: "/en/sitemap/letterInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letterInfo.vue")
  },
  {
    name: "sitemap-letterInfo___zh",
    path: "/sitemap/letterInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letterInfo.vue")
  },
  {
    name: "sitemap-letterInfo___cn",
    path: "/cn/sitemap/letterInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/sitemap/letterInfo.vue")
  },
  {
    name: "fair-formData-nepcon___en",
    path: "/en/fair/formData/nepcon",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/formData/nepcon.ts")
  },
  {
    name: "fair-formData-nepcon___zh",
    path: "/fair/formData/nepcon",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/formData/nepcon.ts")
  },
  {
    name: "fair-formData-nepcon___cn",
    path: "/cn/fair/formData/nepcon",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/formData/nepcon.ts")
  },
  {
    name: "fair-list-index-seo___en",
    path: "/en/fair/list/index-seo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-seo.vue")
  },
  {
    name: "fair-list-index-seo___zh",
    path: "/fair/list/index-seo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-seo.vue")
  },
  {
    name: "fair-list-index-seo___cn",
    path: "/cn/fair/list/index-seo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/list/index-seo.vue")
  },
  {
    name: "fair-periodical_new___en",
    path: "/en/fair/periodical_new",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical_new.vue")
  },
  {
    name: "fair-periodical_new___zh",
    path: "/fair/periodical_new",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical_new.vue")
  },
  {
    name: "fair-periodical_new___cn",
    path: "/cn/fair/periodical_new",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodical_new.vue")
  },
  {
    name: "fair-periodicalList___en",
    path: "/en/fair/periodicalList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodicalList.vue")
  },
  {
    name: "fair-periodicalList___zh",
    path: "/fair/periodicalList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodicalList.vue")
  },
  {
    name: "fair-periodicalList___cn",
    path: "/cn/fair/periodicalList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/periodicalList.vue")
  },
  {
    name: "manager-fair-follow___en",
    path: "/en/manager/fair-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-follow.vue")
  },
  {
    name: "manager-fair-follow___zh",
    path: "/manager/fair-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-follow.vue")
  },
  {
    name: "manager-fair-follow___cn",
    path: "/cn/manager/fair-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-follow.vue")
  },
  {
    name: "manager-fair-remind___en",
    path: "/en/manager/fair-remind",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-remind.vue")
  },
  {
    name: "manager-fair-remind___zh",
    path: "/manager/fair-remind",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-remind.vue")
  },
  {
    name: "manager-fair-remind___cn",
    path: "/cn/manager/fair-remind",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/fair-remind.vue")
  },
  {
    name: "manager-industry-my___en",
    path: "/en/manager/industry-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/industry-my.vue")
  },
  {
    name: "manager-industry-my___zh",
    path: "/manager/industry-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/industry-my.vue")
  },
  {
    name: "manager-industry-my___cn",
    path: "/cn/manager/industry-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/industry-my.vue")
  },
  {
    name: "manager-news-follow___en",
    path: "/en/manager/news-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-follow.vue")
  },
  {
    name: "manager-news-follow___zh",
    path: "/manager/news-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-follow.vue")
  },
  {
    name: "manager-news-follow___cn",
    path: "/cn/manager/news-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/news-follow.vue")
  },
  {
    name: "manager-update-info___en",
    path: "/en/manager/update-info",
    meta: update_45infog_bcsnd1o1z0_rSj3DRFTpsN7372EAHzx7kSIo2rC04Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-info.vue")
  },
  {
    name: "manager-update-info___zh",
    path: "/manager/update-info",
    meta: update_45infog_bcsnd1o1z0_rSj3DRFTpsN7372EAHzx7kSIo2rC04Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-info.vue")
  },
  {
    name: "manager-update-info___cn",
    path: "/cn/manager/update-info",
    meta: update_45infog_bcsnd1o1z0_rSj3DRFTpsN7372EAHzx7kSIo2rC04Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/update-info.vue")
  },
  {
    name: "manager-users-follow___en",
    path: "/en/manager/users-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-follow.vue")
  },
  {
    name: "manager-users-follow___zh",
    path: "/manager/users-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-follow.vue")
  },
  {
    name: "manager-users-follow___cn",
    path: "/cn/manager/users-follow",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/users-follow.vue")
  },
  {
    name: "manager-visitor-edit___en",
    path: "/en/manager/visitor-edit",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit.vue"),
    children: [
  {
    name: "manager-visitor-edit-id___en",
    path: ":id()",
    meta: _91id_93E6fNG_uu5NBkg_BbES3S6GPlUCoD9e_QPiktFPr80c0Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit/[id].vue")
  }
]
  },
  {
    name: "manager-visitor-edit___zh",
    path: "/manager/visitor-edit",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit.vue"),
    children: [
  {
    name: "manager-visitor-edit-id___zh",
    path: ":id()",
    meta: _91id_93E6fNG_uu5NBkg_BbES3S6GPlUCoD9e_QPiktFPr80c0Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit/[id].vue")
  }
]
  },
  {
    name: "manager-visitor-edit___cn",
    path: "/cn/manager/visitor-edit",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit.vue"),
    children: [
  {
    name: "manager-visitor-edit-id___cn",
    path: ":id()",
    meta: _91id_93E6fNG_uu5NBkg_BbES3S6GPlUCoD9e_QPiktFPr80c0Meta || {},
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/visitor-edit/[id].vue")
  }
]
  },
  {
    name: "news-components-News___en",
    path: "/en/news/components/News",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/News.vue")
  },
  {
    name: "news-components-News___zh",
    path: "/news/components/News",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/News.vue")
  },
  {
    name: "news-components-News___cn",
    path: "/cn/news/components/News",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/News.vue")
  },
  {
    name: "news-details-Details___en",
    path: "/en/news/details/Details",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details.vue")
  },
  {
    name: "news-details-Details___zh",
    path: "/news/details/Details",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details.vue")
  },
  {
    name: "news-details-Details___cn",
    path: "/cn/news/details/Details",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details.vue")
  },
  {
    name: "booth-components-card___en",
    path: "/en/booth/components/card",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/components/card.vue")
  },
  {
    name: "booth-components-card___zh",
    path: "/booth/components/card",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/components/card.vue")
  },
  {
    name: "booth-components-card___cn",
    path: "/cn/booth/components/card",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/booth/components/card.vue")
  },
  {
    name: "fair-components-booth___en",
    path: "/en/fair/components/booth",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth.vue")
  },
  {
    name: "fair-components-booth___zh",
    path: "/fair/components/booth",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth.vue")
  },
  {
    name: "fair-components-booth___cn",
    path: "/cn/fair/components/booth",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth.vue")
  },
  {
    name: "fair-components-Route___en",
    path: "/en/fair/components/Route",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/Route.vue")
  },
  {
    name: "fair-components-Route___zh",
    path: "/fair/components/Route",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/Route.vue")
  },
  {
    name: "fair-components-Route___cn",
    path: "/cn/fair/components/Route",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/Route.vue")
  },
  {
    name: "fair-detail-detail-en___en",
    path: "/en/fair/detail/detail-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail-en.vue")
  },
  {
    name: "fair-detail-detail-en___zh",
    path: "/fair/detail/detail-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail-en.vue")
  },
  {
    name: "fair-detail-detail-en___cn",
    path: "/cn/fair/detail/detail-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail-en.vue")
  },
  {
    name: "manager-periodical-my___en",
    path: "/en/manager/periodical-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/periodical-my.vue")
  },
  {
    name: "manager-periodical-my___zh",
    path: "/manager/periodical-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/periodical-my.vue")
  },
  {
    name: "manager-periodical-my___cn",
    path: "/cn/manager/periodical-my",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/periodical-my.vue")
  },
  {
    name: "news-details-exponews___en",
    path: "/en/news/details/exponews",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/exponews.vue")
  },
  {
    name: "news-details-exponews___zh",
    path: "/news/details/exponews",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/exponews.vue")
  },
  {
    name: "news-details-exponews___cn",
    path: "/cn/news/details/exponews",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/exponews.vue")
  },
  {
    name: "pay-components-Poster___en",
    path: "/en/pay/components/Poster",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/components/Poster.vue")
  },
  {
    name: "pay-components-Poster___zh",
    path: "/pay/components/Poster",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/components/Poster.vue")
  },
  {
    name: "pay-components-Poster___cn",
    path: "/cn/pay/components/Poster",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/pay/components/Poster.vue")
  },
  {
    name: "company-components-Pay___en",
    path: "/en/company/components/Pay",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/components/Pay.vue")
  },
  {
    name: "company-components-Pay___zh",
    path: "/company/components/Pay",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/components/Pay.vue")
  },
  {
    name: "company-components-Pay___cn",
    path: "/cn/company/components/Pay",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/company/components/Pay.vue")
  },
  {
    name: "fair-components-booth1___en",
    path: "/en/fair/components/booth1",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth1.vue")
  },
  {
    name: "fair-components-booth1___zh",
    path: "/fair/components/booth1",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth1.vue")
  },
  {
    name: "fair-components-booth1___cn",
    path: "/cn/fair/components/booth1",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/booth1.vue")
  },
  {
    name: "fair-components-poster___en",
    path: "/en/fair/components/poster",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/poster.vue")
  },
  {
    name: "fair-components-poster___zh",
    path: "/fair/components/poster",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/poster.vue")
  },
  {
    name: "fair-components-poster___cn",
    path: "/cn/fair/components/poster",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/poster.vue")
  },
  {
    name: "cooperation-Cooperation___en",
    path: "/en/cooperation/Cooperation",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/cooperation/Cooperation.vue")
  },
  {
    name: "cooperation-Cooperation___zh",
    path: "/cooperation/Cooperation",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/cooperation/Cooperation.vue")
  },
  {
    name: "cooperation-Cooperation___cn",
    path: "/cn/cooperation/Cooperation",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/cooperation/Cooperation.vue")
  },
  {
    name: "fair-components-invoice___en",
    path: "/en/fair/components/invoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/invoice.vue")
  },
  {
    name: "fair-components-invoice___zh",
    path: "/fair/components/invoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/invoice.vue")
  },
  {
    name: "fair-components-invoice___cn",
    path: "/cn/fair/components/invoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/invoice.vue")
  },
  {
    name: "fair-components-newItem___en",
    path: "/en/fair/components/newItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newItem.vue")
  },
  {
    name: "fair-components-newItem___zh",
    path: "/fair/components/newItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newItem.vue")
  },
  {
    name: "fair-components-newItem___cn",
    path: "/cn/fair/components/newItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newItem.vue")
  },
  {
    name: "fair-components-subsidy___en",
    path: "/en/fair/components/subsidy",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/subsidy.vue")
  },
  {
    name: "fair-components-subsidy___zh",
    path: "/fair/components/subsidy",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/subsidy.vue")
  },
  {
    name: "fair-components-subsidy___cn",
    path: "/cn/fair/components/subsidy",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/subsidy.vue")
  },
  {
    name: "fair-detail-detail1-seo___en",
    path: "/en/fair/detail/detail1-seo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail1-seo.vue")
  },
  {
    name: "fair-detail-detail1-seo___zh",
    path: "/fair/detail/detail1-seo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail1-seo.vue")
  },
  {
    name: "fair-detail-detail1-seo___cn",
    path: "/cn/fair/detail/detail1-seo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/detail/detail1-seo.vue")
  },
  {
    name: "home-components-EveFair___en",
    path: "/en/home/components/EveFair",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/EveFair.vue")
  },
  {
    name: "home-components-EveFair___zh",
    path: "/home/components/EveFair",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/EveFair.vue")
  },
  {
    name: "home-components-EveFair___cn",
    path: "/cn/home/components/EveFair",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/EveFair.vue")
  },
  {
    name: "news-details-Details-en___en",
    path: "/en/news/details/Details-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details-en.vue")
  },
  {
    name: "news-details-Details-en___zh",
    path: "/news/details/Details-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details-en.vue")
  },
  {
    name: "news-details-Details-en___cn",
    path: "/cn/news/details/Details-en",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/details/Details-en.vue")
  },
  {
    name: "home-components-FairItem___en",
    path: "/en/home/components/FairItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/FairItem.vue")
  },
  {
    name: "home-components-FairItem___zh",
    path: "/home/components/FairItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/FairItem.vue")
  },
  {
    name: "home-components-FairItem___cn",
    path: "/cn/home/components/FairItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/FairItem.vue")
  },
  {
    name: "home-components-NewsList___en",
    path: "/en/home/components/NewsList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/NewsList.vue")
  },
  {
    name: "home-components-NewsList___zh",
    path: "/home/components/NewsList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/NewsList.vue")
  },
  {
    name: "home-components-NewsList___cn",
    path: "/cn/home/components/NewsList",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components/NewsList.vue")
  },
  {
    name: "news-components-NewsItem___en",
    path: "/en/news/components/NewsItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/NewsItem.vue")
  },
  {
    name: "news-components-NewsItem___zh",
    path: "/news/components/NewsItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/NewsItem.vue")
  },
  {
    name: "news-components-NewsItem___cn",
    path: "/cn/news/components/NewsItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/NewsItem.vue")
  },
  {
    name: "fair-components-newDetail___en",
    path: "/en/fair/components/newDetail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newDetail.vue")
  },
  {
    name: "fair-components-newDetail___zh",
    path: "/fair/components/newDetail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newDetail.vue")
  },
  {
    name: "fair-components-newDetail___cn",
    path: "/cn/fair/components/newDetail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/newDetail.vue")
  },
  {
    name: "fair-components-NewsItem2___en",
    path: "/en/fair/components/NewsItem2",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/NewsItem2.vue")
  },
  {
    name: "fair-components-NewsItem2___zh",
    path: "/fair/components/NewsItem2",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/NewsItem2.vue")
  },
  {
    name: "fair-components-NewsItem2___cn",
    path: "/cn/fair/components/NewsItem2",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/NewsItem2.vue")
  },
  {
    name: "fair-components-orderInfo___en",
    path: "/en/fair/components/orderInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/orderInfo.vue")
  },
  {
    name: "fair-components-orderInfo___zh",
    path: "/fair/components/orderInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/orderInfo.vue")
  },
  {
    name: "fair-components-orderInfo___cn",
    path: "/cn/fair/components/orderInfo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/orderInfo.vue")
  },
  {
    name: "fair-components-evaluation___en",
    path: "/en/fair/components/evaluation",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/evaluation.vue")
  },
  {
    name: "fair-components-evaluation___zh",
    path: "/fair/components/evaluation",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/evaluation.vue")
  },
  {
    name: "fair-components-evaluation___cn",
    path: "/cn/fair/components/evaluation",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/evaluation.vue")
  },
  {
    name: "fair-components-rightFloat___en",
    path: "/en/fair/components/rightFloat",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/rightFloat.vue")
  },
  {
    name: "fair-components-rightFloat___zh",
    path: "/fair/components/rightFloat",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/rightFloat.vue")
  },
  {
    name: "fair-components-rightFloat___cn",
    path: "/cn/fair/components/rightFloat",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/rightFloat.vue")
  },
  {
    name: "fair-components-ServerStep___en",
    path: "/en/fair/components/ServerStep",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/ServerStep.vue")
  },
  {
    name: "fair-components-ServerStep___zh",
    path: "/fair/components/ServerStep",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/ServerStep.vue")
  },
  {
    name: "fair-components-ServerStep___cn",
    path: "/cn/fair/components/ServerStep",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/ServerStep.vue")
  },
  {
    name: "news-components-RelatedNew___en",
    path: "/en/news/components/RelatedNew",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/RelatedNew.vue")
  },
  {
    name: "news-components-RelatedNew___zh",
    path: "/news/components/RelatedNew",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/RelatedNew.vue")
  },
  {
    name: "news-components-RelatedNew___cn",
    path: "/cn/news/components/RelatedNew",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/news/components/RelatedNew.vue")
  },
  {
    name: "fair-components-detailTopBg___en",
    path: "/en/fair/components/detailTopBg",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/detailTopBg.vue")
  },
  {
    name: "fair-components-detailTopBg___zh",
    path: "/fair/components/detailTopBg",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/detailTopBg.vue")
  },
  {
    name: "fair-components-detailTopBg___cn",
    path: "/cn/fair/components/detailTopBg",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/detailTopBg.vue")
  },
  {
    name: "fair-components-FairItemSeo___en",
    path: "/en/fair/components/FairItemSeo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/FairItemSeo.vue")
  },
  {
    name: "fair-components-FairItemSeo___zh",
    path: "/fair/components/FairItemSeo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/FairItemSeo.vue")
  },
  {
    name: "fair-components-FairItemSeo___cn",
    path: "/cn/fair/components/FairItemSeo",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/FairItemSeo.vue")
  },
  {
    name: "fair-components-goodsDetail___en",
    path: "/en/fair/components/goodsDetail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/goodsDetail.vue")
  },
  {
    name: "fair-components-goodsDetail___zh",
    path: "/fair/components/goodsDetail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/goodsDetail.vue")
  },
  {
    name: "fair-components-goodsDetail___cn",
    path: "/cn/fair/components/goodsDetail",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/goodsDetail.vue")
  },
  {
    name: "manager-components-myUpload___en",
    path: "/en/manager/components/myUpload",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/myUpload.vue")
  },
  {
    name: "manager-components-myUpload___zh",
    path: "/manager/components/myUpload",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/myUpload.vue")
  },
  {
    name: "manager-components-myUpload___cn",
    path: "/cn/manager/components/myUpload",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/myUpload.vue")
  },
  {
    name: "manager-components-VisaItem___en",
    path: "/en/manager/components/VisaItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaItem.vue")
  },
  {
    name: "manager-components-VisaItem___zh",
    path: "/manager/components/VisaItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaItem.vue")
  },
  {
    name: "manager-components-VisaItem___cn",
    path: "/cn/manager/components/VisaItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaItem.vue")
  },
  {
    name: "fair-components-resourceView___en",
    path: "/en/fair/components/resourceView",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/resourceView.vue")
  },
  {
    name: "fair-components-resourceView___zh",
    path: "/fair/components/resourceView",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/resourceView.vue")
  },
  {
    name: "fair-components-resourceView___cn",
    path: "/cn/fair/components/resourceView",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/resourceView.vue")
  },
  {
    name: "manager-components-Repayment___en",
    path: "/en/manager/components/Repayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/Repayment.vue")
  },
  {
    name: "manager-components-Repayment___zh",
    path: "/manager/components/Repayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/Repayment.vue")
  },
  {
    name: "manager-components-Repayment___cn",
    path: "/cn/manager/components/Repayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/Repayment.vue")
  },
  {
    name: "fair-components-dialogSubsidy___en",
    path: "/en/fair/components/dialogSubsidy",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/dialogSubsidy.vue")
  },
  {
    name: "fair-components-dialogSubsidy___zh",
    path: "/fair/components/dialogSubsidy",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/dialogSubsidy.vue")
  },
  {
    name: "fair-components-dialogSubsidy___cn",
    path: "/cn/fair/components/dialogSubsidy",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/fair/components/dialogSubsidy.vue")
  },
  {
    name: "home-components-en-ExpoCardEn___en",
    path: "/en/home/components-en/ExpoCardEn",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/ExpoCardEn.vue")
  },
  {
    name: "home-components-en-ExpoCardEn___zh",
    path: "/home/components-en/ExpoCardEn",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/ExpoCardEn.vue")
  },
  {
    name: "home-components-en-ExpoCardEn___cn",
    path: "/cn/home/components-en/ExpoCardEn",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/ExpoCardEn.vue")
  },
  {
    name: "manager-components-GetInvoice___en",
    path: "/en/manager/components/GetInvoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/GetInvoice.vue")
  },
  {
    name: "manager-components-GetInvoice___zh",
    path: "/manager/components/GetInvoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/GetInvoice.vue")
  },
  {
    name: "manager-components-GetInvoice___cn",
    path: "/cn/manager/components/GetInvoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/GetInvoice.vue")
  },
  {
    name: "manager-components-TicketItem___en",
    path: "/en/manager/components/TicketItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/TicketItem.vue")
  },
  {
    name: "manager-components-TicketItem___zh",
    path: "/manager/components/TicketItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/TicketItem.vue")
  },
  {
    name: "manager-components-TicketItem___cn",
    path: "/cn/manager/components/TicketItem",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/TicketItem.vue")
  },
  {
    name: "manager-components-LookInvoice___en",
    path: "/en/manager/components/LookInvoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/LookInvoice.vue")
  },
  {
    name: "manager-components-LookInvoice___zh",
    path: "/manager/components/LookInvoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/LookInvoice.vue")
  },
  {
    name: "manager-components-LookInvoice___cn",
    path: "/cn/manager/components/LookInvoice",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/LookInvoice.vue")
  },
  {
    name: "manager-components-VisaRepayment___en",
    path: "/en/manager/components/VisaRepayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaRepayment.vue")
  },
  {
    name: "manager-components-VisaRepayment___zh",
    path: "/manager/components/VisaRepayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaRepayment.vue")
  },
  {
    name: "manager-components-VisaRepayment___cn",
    path: "/cn/manager/components/VisaRepayment",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/manager/components/VisaRepayment.vue")
  },
  {
    name: "home-components-en-IndustryCardEn___en",
    path: "/en/home/components-en/IndustryCardEn",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustryCardEn.vue")
  },
  {
    name: "home-components-en-IndustryCardEn___zh",
    path: "/home/components-en/IndustryCardEn",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustryCardEn.vue")
  },
  {
    name: "home-components-en-IndustryCardEn___cn",
    path: "/cn/home/components-en/IndustryCardEn",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustryCardEn.vue")
  },
  {
    name: "home-components-en-IndustrySubPopover___en",
    path: "/en/home/components-en/IndustrySubPopover",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustrySubPopover.vue")
  },
  {
    name: "home-components-en-IndustrySubPopover___zh",
    path: "/home/components-en/IndustrySubPopover",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustrySubPopover.vue")
  },
  {
    name: "home-components-en-IndustrySubPopover___cn",
    path: "/cn/home/components-en/IndustrySubPopover",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/home/components-en/IndustrySubPopover.vue")
  },
  {
    name: "visa-visa-visaAreaId-areaId-type-bizType-page___en",
    path: "/en/visa/visa-:visaAreaId()-:areaId()-:type()-:bizType()-:page()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/visa-[visaAreaId]-[areaId]-[type]-[bizType]-[page].vue")
  },
  {
    name: "visa-visa-visaAreaId-areaId-type-bizType-page___zh",
    path: "/visa/visa-:visaAreaId()-:areaId()-:type()-:bizType()-:page()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/visa-[visaAreaId]-[areaId]-[type]-[bizType]-[page].vue")
  },
  {
    name: "visa-visa-visaAreaId-areaId-type-bizType-page___cn",
    path: "/cn/visa/visa-:visaAreaId()-:areaId()-:type()-:bizType()-:page()",
    component: () => import("/root/workspace/com.jufair.pc.nuxt3_46wE/app/pages/visa/visa-[visaAreaId]-[areaId]-[type]-[bizType]-[page].vue")
  }
]